import { createActions, createReducer } from "reduxsauce";
import { defaultState } from "./nps-model";

export const updateKeycloakToken = (state, action) => ({
  ...state,
  keycloakToken: action.keycloakToken,
});

export const { Types, Creators } = createActions({
  npsUpdateKeycloakToken: ["keycloakToken"],
  npsGetKeycloakTokenAsync: [],
});

export default createReducer(defaultState, {
  [Types.NPS_UPDATE_KEYCLOAK_TOKEN]: updateKeycloakToken,
});
